import { Provider } from './financing-api';

/**
 * Resolves a provider name string (e.g. `'Turns'`, `'GreenSky'`) to the matching
 * {@link Provider} enum value (e.g. `'turns'`, `'greenSky'`).
 *
 * Provider names in tenant settings and API responses often use PascalCase, while
 * the Provider enum values use lowercase/camelCase. Pass through this function before
 * using a dynamic provider name in an API call so the URL path segment is correct.
 *
 * Falls back to the input string cast as Provider when no match is found.
 *
 * NOTE: This lives outside the generated `financing-api.ts` so it survives
 * `npm run generate-api` regenerations.
 */
export const resolveProviderEnum = (name: string): Provider =>
    (Object.values(Provider).find(v => v.toLowerCase() === name.toLowerCase()) ?? name) as Provider;
